import { useEffect, useState } from "react";
import { AsideAdminComponent } from "../layout/aside-admin";
import {
  PageType,
  ComponentTabLink,
  ITabTitle,
} from "../components/component-tab";
import { ITabLink } from "../components/component-tab";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import React from "react";
import exit from "../assets/icon/exit.png";
import { activeServiceId, eDate, pageIndicator, sDate } from "../apollo";
import { useListOrder } from "../hooks/useListOrder";
import { useEditOrderStatus } from "../hooks/useEditOrderStatus";

import { TableError } from "../components/table-error";
import { PaginationComponent } from "../components/pagination";
import moment from "moment";
import { ListOrder } from "./admin-list-order";
import {
  OrderStatus,
  ListOrderInput,
  EditOrderStatusInput,
  EditOrderStatusMutation,
  EditOrderEndDateMutation,
  EditOrderEndDateInput,
  EditReceiptAddressMutation,
  EditReceiptAddressInput,
} from "../generated/graphql";
import {
  IEditOrderEndFormProps,
  useEditOrderEndDate,
} from "../hooks/useEditOrderEndDate";
import { useForm } from "react-hook-form";
import {
  IEditReceiptAddressFormProps,
  useEditReceiptAddress,
} from "../hooks/useEditReceiptAddress";

export const AdminListOrderConfirm = () => {
  const location = useLocation();
  const word = "배송확정";
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");
  const [stateId, setStateId] = useState<number>(1);
  const [change, setChange] = React.useState<OrderStatus>(OrderStatus.Complete);
  const [checkedLists, setCheckedLists] = useState<ListOrder[]>([]);
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [allChecked, setAllChecked] = useState<boolean>(false);
  const [edit, setEdit] = useState(false);
  const navigate = useNavigate();

  // --- Component ---
  const tabList: ITabLink[] = [
    { text: "주문확인", to: "/order" },
    { text: "출고대기", to: "/release" },
    { text: "배송준비중", to: "/order/delivery" },
    { text: "배송중", to: "/order/start" },
    { text: "배송완료", to: "/order/end" },
    { text: "교환/환불", to: "/order/exchange" },
    { text: "배송확정", to: "/order/confirm", selected: true },
  ];
  const stitle: ITabTitle = {
    text: "배송관리",
  };

  const StateHandler = (id: number) => {
    setStateId(id);
    setOpen(true);
  };
  const [listOrder, { data, loading, refetch }] = useListOrder();
  const listOrderHandler = (
    page: number | null,
    search: string | null,
    statuses: OrderStatus[],
    start?: Date | null,
    end?: Date | null
  ) => {
    const input: ListOrderInput = {
      ...(page && { page: +page }),
      ...(search && { search: decodeURI(search) }),
      ...(statuses.length > 0 && { statuses }),
      ...(start && { start }),
      ...(end && { end }),
      ...(activeServiceId() && { serviceId: activeServiceId()! }),
    };
    listOrder({ variables: { input } });
  };

  // --- 상태 변경 ---
  const onEditCompleted = async (data: EditOrderStatusMutation) => {
    const {
      editOrderStatus: { ok, err },
    } = data;
    if (ok) {
      // alert(`주문상태가 수정되었습니다.`);
      await refetch();
    } else {
      alert(err);
    }
  };
  const [
    editOrderStatus,
    { loading: editOrderStatusLoading },
  ] = useEditOrderStatus(onEditCompleted);
  const editOrderStatusHandler = (orderId: number, status: OrderStatus) => {
    if (!editOrderStatusLoading) {
      const editOrderStatusInput: EditOrderStatusInput = {
        orderId,
        status,
      };
      editOrderStatus({ variables: { input: editOrderStatusInput } });
    }
  };

  // --- CheckBox ---
  const setAllCheckedHandler = () => {
    setAllChecked(!allChecked);
    if (allChecked) setCheckedLists([]);

    if (!allChecked && data?.listOrder.orders) {
      setCheckedLists([]);
      for (const confirm of data?.listOrder.orders) {
        setCheckedLists((checkedList) => [...checkedList, confirm]);
      }
    }
  };

  const setCheckedListHandler = (confirmId: number, data: any) => {
    if (Boolean(checkedLists.find((checkedId) => checkedId.id === confirmId))) {
      setCheckedLists(
        checkedLists.filter((checkedId) => checkedId.id !== confirmId)
      );
    } else {
      setCheckedLists((originalList) => [...originalList, data]);
    }
  };
  useEffect(() => {
    if (checkedLists.length === data?.listOrder.orders?.length)
      setAllChecked(true);
    else setAllChecked(false);
  }, [checkedLists]);

  // --- Search ---
  const setSearchHandler = (search: string) => {
    navigate({
      pathname: "/order/confirm",
      search: `${search ? `?search=${search}` : ""}`,
    });
    const statuses: OrderStatus[] = [OrderStatus.Complete];
    listOrderHandler(1, search, statuses);
  };

  // --- Address 변경 ---
  const addressModalDataHandler = (address: ListOrder) => {
    addressSetValue("receiptId", address.receipt?.id ? address.receipt.id : 1);
    addressSetValue("address", address.receipt?.address);
  };
  const [editAddress, setEditAddress] = useState(false);
  const {
    register: addressRegister,
    handleSubmit: addressHandleSubmit,
    getValues: addressGetValues,
    setValue: addressSetValue,
    formState: { errors: addressErros, isValid: addressIsValid },
  } = useForm<IEditReceiptAddressFormProps>({ mode: "all" });
  const onEditAddressComplete = (data: EditReceiptAddressMutation) => {
    const {
      editReceiptAddress: { ok, err },
    } = data;
    if (ok) {
      window.location.href = "/order/confirm";
    }
  };
  const [
    editReceiptAddress,
    { loading: editReceiptAddressLoading },
  ] = useEditReceiptAddress(onEditAddressComplete);
  const addressSubmit = () => {
    if (!editReceiptAddressLoading) {
      const { address, receiptId } = addressGetValues();
      const editReceiptAddressInput: EditReceiptAddressInput = {
        receiptId: receiptId ? +receiptId : 1,
        address,
      };
      editReceiptAddress({ variables: { input: editReceiptAddressInput } });
      setEditAddress(true);
    }
  };
  // --- Address 변경 ---

  // --- 배송완료 시간 변경 ---
  const transModalDataHandler = (end: ListOrder) => {
    setValue("endDate", moment(end.EndDate).format("YYYY-MM-DD HH:mm"));
    setValue("orderId", end.id);
  };

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors, isValid },
  } = useForm<IEditOrderEndFormProps>({ mode: "all" });
  const onEditComplete = (data: EditOrderEndDateMutation) => {
    const {
      editOrderEndDate: { ok, err },
    } = data;
    if (ok) {
      window.location.href = "/order/confirm";
    } else {
      alert(err);
    }
  };
  const [
    editOrderEndDate,
    { loading: editOrderEndDateLoading },
  ] = useEditOrderEndDate(onEditComplete);

  const onSubmit = () => {
    if (!editOrderEndDateLoading) {
      const { endDate, orderId } = getValues();
      const editOrderEndDateInput: EditOrderEndDateInput = {
        orderId: orderId ? +orderId : 1,
        endDate,
      };
      editOrderEndDate({ variables: { input: editOrderEndDateInput } });
      setEdit(false);
    }
  };
  // --- Page ---
  const pageHandler = (page: number) => {
    const search =
      location.search.split("search=").length > 1
        ? location.search.split("search=")[1].split("&")[0]
        : null;
    setPage(page);
    navigate({
      pathname: "/order/confirm",
      search: `?page=${page}${search ? `&search=${search}` : ""}`,
    });
    const statuses: OrderStatus[] = [OrderStatus.Complete];
    listOrderHandler(page, search, statuses, startDate, endDate);
  };

  // --- Period ---
  const periodHandler = (sDate?: Date, eDate?: Date) => {
    const statuses: OrderStatus[] = [OrderStatus.Complete];
    setStartDate(sDate);
    setEndDate(eDate);
    listOrderHandler(1, search, statuses, sDate, eDate);
  };
  // ---  ---
  useEffect(() => {
    pageIndicator("delivery");
    setPage(
      location.search.split("page=").length > 1
        ? +location.search.split("page=")[1].split("&")[0]
        : 1
    );
    setSearch(
      location.search.split("search=").length > 1
        ? location.search.split("search=")[1].split("&")[0]
        : ""
    );
    const statuses: OrderStatus[] = [OrderStatus.Complete];
    listOrderHandler(page, search, statuses, startDate, endDate);
  }, [search, page]);

  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen  bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      type={PageType.Confirm}
                      dataList={checkedLists}
                      setSearchs={setSearchHandler}
                      setDateSearch={periodHandler}
                    />

                    {/* 목록 */}
                    <div className=" shadow-lg h-[800px] h-fix-content w-full overflow-auto bg-white">
                      <table className="align-center w-[1623px]  text-sm  border-[#F9F8F9] ">
                        <thead>
                          <tr className=" border-b border-[#F9F8F9] h-8">
                            <th className="text-[#8B8C8C] leading-3">
                              <input
                                type="checkbox"
                                className="w-5 h-5"
                                name="allChk"
                                checked={allChecked}
                                onChange={setAllCheckedHandler}
                              />
                            </th>
                            <th className="text-[#8B8C8C] min-w-[36px]">no</th>
                            <th className="text-[#8B8C8C] min-w-[64px]">
                              상태
                            </th>
                            {/* <th className="text-[#8B8C8C] min-w-[88px]">
                              주문번호
                            </th>
                            <th className="text-[#8B8C8C] min-w-[112px]">
                              QR코드/송장번호
                            </th>
                            <th className="text-[#8B8C8C] min-w-[112px]">
                              주문날짜
                            </th> */}

                            <th className="text-[#8B8C8C] min-w-[88px]">
                              배송완료시간
                            </th>
                            <th className="text-[#8B8C8C] min-w-[168px]">
                              상품명
                            </th>
                            <th className="text-[#8B8C8C] min-w-[168px]">
                              상품옵션
                            </th>
                            <th className="text-[#8B8C8C] min-w-[48px]">
                              수량
                            </th>
                            <th className="text-[#8B8C8C] min-w-[88px]">
                              결제금액
                            </th>
                            <th className="text-[#8B8C8C] min-w-[88px]">
                              주문자
                            </th>
                            <th className="text-[#8B8C8C] min-w-[88px]">
                              수취인
                            </th>
                            <th className="text-[#8B8C8C] min-w-[168px]">
                              주소
                            </th>
                            <th className="text-[#8B8C8C] min-w-[128px]">
                              연락처
                            </th>
                            <th className="text-[#8B8C8C] min-w-[80px]">
                              비고
                            </th>
                          </tr>
                        </thead>

                        <tbody className="">
                          {!loading &&
                            data?.listOrder.orders &&
                            data.listOrder.orders.map((confirm, index) => (
                              <tr
                                key={`confirm-${confirm.id}`}
                                className="border-b border-[#F9F8F9] h-[68px]"
                              >
                                <td className="table-text">
                                  <input
                                    type="checkbox"
                                    className="h-5 w-5"
                                    checked={
                                      checkedLists.find(
                                        (checkedId) =>
                                          checkedId.id === confirm.id
                                      ) !== undefined
                                    }
                                    onChange={(e) => {
                                      setCheckedListHandler(
                                        confirm.id,
                                        confirm
                                      );
                                    }}
                                  />
                                </td>
                                <td className="table-text">
                                  {(page - 1) * 20 + index + 1}
                                </td>
                                <td className="table-text">
                                  <button
                                    onClick={() => {
                                      StateHandler(confirm.id);
                                      setChange(confirm.status);
                                    }}
                                    className="border border-[#3D3E49] rounded-lg py-[4px] px-[3px] w-[48px] h-10 text-[#3D3E49] font-bold keep-all"
                                  >
                                    {confirm.status === "Complete"
                                      ? "배송 확정"
                                      : ""}
                                  </button>
                                </td>
                                {/* <td className="table-text break-all">
                                  {confirm.receipt?.receiptNum}
                                </td>
                                <td className="table-text font-bold"></td>
                                <td className="table-text font-bold">
                                  {confirm.createdAt &&
                                    moment(confirm.createdAt).format("YYMMDD")}
                                </td> */}
                                <td className="table-text font-bold">
                                  <button
                                    onClick={() => {
                                      setEdit(true);
                                      transModalDataHandler(confirm);
                                    }}
                                    className="table-text font-bold"
                                  >
                                    {confirm.EndDate &&
                                      moment(confirm.EndDate).format(
                                        "YYMMDD"
                                      )}{" "}
                                    <br />
                                    {confirm.EndDate &&
                                      moment(confirm.EndDate).format("H : mm")}
                                  </button>
                                </td>
                                <td className="table-text">
                                  {confirm.good?.title}
                                </td>
                                <td className="table-text">
                                  {confirm.goodOptionName}
                                </td>
                                <td className="table-text">
                                  {confirm.quantity}
                                </td>
                                <td className="table-text">{confirm.amount}</td>
                                <td className="table-text font-bold">
                                  {confirm.receipt?.user?.name}
                                </td>
                                <td className="table-text font-bold">
                                  {confirm.receipt?.receiver}
                                </td>
                                <td className="table-text">
                                  <button
                                    onClick={() => {
                                      setEditAddress(true);
                                      addressModalDataHandler(confirm);
                                    }}
                                  >
                                    {confirm.receipt?.address}
                                  </button>
                                </td>
                                <td className="table-text">
                                  {confirm.receipt?.phone}
                                </td>
                                <td className="table-text"></td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      {loading && (
                        <TableError errorMessage={`정보를 불러오는중입니다`} />
                      )}
                      {!loading &&
                        data?.listOrder.orders &&
                        data.listOrder.orders.length < 1 && (
                          <TableError
                            errorMessage={`${word} 정보가 없습니다`}
                          />
                        )}

                      {!loading &&
                        data?.listOrder.orders &&
                        data.listOrder.orders.length > 0 && (
                          <PaginationComponent
                            page={page}
                            totalPages={Number(data.listOrder.totalPages)}
                            totalResults={Number(data.listOrder.totalResults)}
                            pageHandler={pageHandler}
                          />
                        )}
                      <Modal
                        open={open}
                        onClose={() => {
                          setOpen(false);
                        }}
                      >
                        <div className="max-w-[360px] w-full absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2   bg-[#F9F8F9] rounded-lg">
                          <div className="text-center py-2 h-10 text-white font-bold bg-[#3D3E49] rounded-t-lg  ">
                            <div className="flex flex-wrap justify-between">
                              <p className="w-[240px] ml-[40px] font-bold text-base">
                                배송 상태변경
                              </p>
                              <img
                                src={exit}
                                alt="닫기"
                                className="w-6 mr-2 cursor-pointer"
                                onClick={() => setOpen(false)}
                              ></img>
                            </div>
                          </div>
                          <div className="flex flex-wrap content-center">
                            <div className="px-10 py-10">
                              <div className="grid grid-rows-3 gap-y-4">
                                <div>
                                  <input
                                    type="radio"
                                    name="order"
                                    id="check"
                                    value="Delivered"
                                    checked={change === OrderStatus.Delivered}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setChange(OrderStatus.Delivered);
                                      }
                                    }}
                                  ></input>
                                  <span className="ml-4">배송 완료</span>
                                </div>

                                <div>
                                  <input
                                    type="radio"
                                    name="order"
                                    id="Complete"
                                    defaultChecked
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setChange(OrderStatus.Complete);
                                      }
                                    }}
                                  ></input>
                                  <span className="ml-4">확정</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button
                            className="w-full h-14 bg-[#F0F0F4] rounded-b-lg"
                            onClick={() => {
                              editOrderStatusHandler(stateId, change);
                              setOpen(false);
                            }}
                          >
                            확인
                          </button>
                        </div>
                      </Modal>
                      <Modal
                        open={edit}
                        onClose={() => {
                          setEdit(false);
                        }}
                      >
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <div className="max-w-[360px] w-full absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#F9F8F9] rounded-lg">
                            <div className="text-center py-2 h-10 text-white font-bold bg-[#3D3E49] rounded-t-lg  ">
                              <div className="flex flex-wrap justify-between">
                                <p className="w-[240px] ml-[40px] font-bold text-base">
                                  배송완료 시간 변경
                                </p>
                                <img
                                  src={exit}
                                  alt="닫기"
                                  className="w-6 mr-2 cursor-pointer"
                                  onClick={() => setEdit(false)}
                                ></img>
                              </div>
                            </div>
                            <div className="px-10 py-10">
                              <div className="space-y-5">
                                <div className="space-y-3">
                                  <p className="font-bold text-[#8B8C8C] text-sm">
                                    배송완료시간
                                  </p>
                                  <input
                                    {...register("endDate", {
                                      required: `출발시간을 입력해주세요`,
                                    })}
                                    type="datetime-local"
                                    className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                                  />
                                </div>
                              </div>
                            </div>
                            <button
                              type="submit"
                              className="w-full h-14 bg-[#F0F0F4] rounded-b-lg"
                            >
                              {loading ? "Loading..." : "확인"}
                            </button>
                          </div>
                        </form>
                      </Modal>
                      <Modal
                        open={editAddress}
                        onClose={() => {
                          setEditAddress(false);
                        }}
                      >
                        <form onSubmit={addressHandleSubmit(addressSubmit)}>
                          <div className="max-w-[360px] w-full absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#F9F8F9] rounded-lg">
                            <div className="text-center py-2 h-10 text-white font-bold bg-[#3D3E49] rounded-t-lg  ">
                              <div className="flex flex-wrap justify-between">
                                <p className="w-[240px] ml-[40px] font-bold text-base">
                                  주소 변경
                                </p>
                                <img
                                  src={exit}
                                  alt="닫기"
                                  className="w-6 mr-2 cursor-pointer"
                                  onClick={() => setEditAddress(false)}
                                ></img>
                              </div>
                            </div>
                            <div className="px-10 py-10">
                              <div className="space-y-5">
                                <div className="space-y-3">
                                  <p className="font-bold text-[#8B8C8C] text-sm">
                                    주소 변경
                                  </p>
                                  <input
                                    {...addressRegister("address")}
                                    type="text"
                                    className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                                  />
                                </div>
                              </div>
                            </div>
                            <button
                              type="submit"
                              className="w-full h-14 bg-[#F0F0F4] rounded-b-lg"
                            >
                              {loading ? "Loading..." : "확인"}
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
